import { render } from "./Confidentiality.vue?vue&type=template&id=1850a560&scoped=true"
import script from "./Confidentiality.vue?vue&type=script&lang=js"
export * from "./Confidentiality.vue?vue&type=script&lang=js"

import "./Confidentiality.vue?vue&type=style&index=0&id=1850a560&lang=scss&scoped=true"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1850a560"]])

export default __exports__